/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.SmsMessageDropdownFilter = (function() {

    /**
     * Namespace SmsMessageDropdownFilter.
     * @exports SmsMessageDropdownFilter
     * @namespace
     */
    var SmsMessageDropdownFilter = {};

    SmsMessageDropdownFilter.SmsMessageDropdownFilterModel = (function() {

        /**
         * Properties of a SmsMessageDropdownFilterModel.
         * @memberof SmsMessageDropdownFilter
         * @interface ISmsMessageDropdownFilterModel
         * @property {string|null} [message] SmsMessageDropdownFilterModel message
         * @property {number|null} [pageIndex] SmsMessageDropdownFilterModel pageIndex
         * @property {number|null} [pageSize] SmsMessageDropdownFilterModel pageSize
         */

        /**
         * Constructs a new SmsMessageDropdownFilterModel.
         * @memberof SmsMessageDropdownFilter
         * @classdesc Represents a SmsMessageDropdownFilterModel.
         * @implements ISmsMessageDropdownFilterModel
         * @constructor
         * @param {SmsMessageDropdownFilter.ISmsMessageDropdownFilterModel=} [p] Properties to set
         */
        function SmsMessageDropdownFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SmsMessageDropdownFilterModel message.
         * @member {string|null|undefined} message
         * @memberof SmsMessageDropdownFilter.SmsMessageDropdownFilterModel
         * @instance
         */
        SmsMessageDropdownFilterModel.prototype.message = null;

        /**
         * SmsMessageDropdownFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof SmsMessageDropdownFilter.SmsMessageDropdownFilterModel
         * @instance
         */
        SmsMessageDropdownFilterModel.prototype.pageIndex = null;

        /**
         * SmsMessageDropdownFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof SmsMessageDropdownFilter.SmsMessageDropdownFilterModel
         * @instance
         */
        SmsMessageDropdownFilterModel.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * SmsMessageDropdownFilterModel _message.
         * @member {"message"|undefined} _message
         * @memberof SmsMessageDropdownFilter.SmsMessageDropdownFilterModel
         * @instance
         */
        Object.defineProperty(SmsMessageDropdownFilterModel.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * SmsMessageDropdownFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof SmsMessageDropdownFilter.SmsMessageDropdownFilterModel
         * @instance
         */
        Object.defineProperty(SmsMessageDropdownFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * SmsMessageDropdownFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof SmsMessageDropdownFilter.SmsMessageDropdownFilterModel
         * @instance
         */
        Object.defineProperty(SmsMessageDropdownFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified SmsMessageDropdownFilterModel message. Does not implicitly {@link SmsMessageDropdownFilter.SmsMessageDropdownFilterModel.verify|verify} messages.
         * @function encode
         * @memberof SmsMessageDropdownFilter.SmsMessageDropdownFilterModel
         * @static
         * @param {SmsMessageDropdownFilter.ISmsMessageDropdownFilterModel} m SmsMessageDropdownFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SmsMessageDropdownFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.message != null && Object.hasOwnProperty.call(m, "message"))
                w.uint32(10).string(m.message);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(16).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(24).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified SmsMessageDropdownFilterModel message, length delimited. Does not implicitly {@link SmsMessageDropdownFilter.SmsMessageDropdownFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof SmsMessageDropdownFilter.SmsMessageDropdownFilterModel
         * @static
         * @param {SmsMessageDropdownFilter.ISmsMessageDropdownFilterModel} message SmsMessageDropdownFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SmsMessageDropdownFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SmsMessageDropdownFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof SmsMessageDropdownFilter.SmsMessageDropdownFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {SmsMessageDropdownFilter.SmsMessageDropdownFilterModel} SmsMessageDropdownFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SmsMessageDropdownFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.SmsMessageDropdownFilter.SmsMessageDropdownFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.message = r.string();
                    break;
                case 2:
                    m.pageIndex = r.int32();
                    break;
                case 3:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a SmsMessageDropdownFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof SmsMessageDropdownFilter.SmsMessageDropdownFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {SmsMessageDropdownFilter.SmsMessageDropdownFilterModel} SmsMessageDropdownFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SmsMessageDropdownFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return SmsMessageDropdownFilterModel;
    })();

    return SmsMessageDropdownFilter;
})();

module.exports = $root;
